import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dasher',
})
export class DasherPipe implements PipeTransform {
  transform(value: string | number, ...args) {
    return value == null || value === '' || value === 'null' ? '-' : value;
  }
}



// WEBPACK FOOTER //
// ./src/shared/pipes/dasher/dasher.ts